export default function generateUuid() {
	return Math.random().toString() +
		Math.random().toString() +
		Math.random().toString();
}
